<footer class="footer">
    <div class="container-fluid">
        <div class="row">
            <div class="col-sm-6">
                {{year()}} ©.
            </div>
            <div class="col-sm-6">
                <!-- <a href="#" target="_blank" style="text-decoration: none;color: inherit;"> -->
                    <a style="text-decoration: none;color: inherit;">
                    <div class="text-sm-end cursor-pointer">
                        <img id="aboutFooter" [src]="logoSrc" width="30px"  alt=""> ICollector
                    </div>
                </a>
            </div>
        </div>
    </div>
</footer>